import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AxiosResponse } from 'axios';
import { CSVLink } from "react-csv";
import moment from 'moment';
import { Button, Card, CardBody, CardHeader, Container } from 'reactstrap';

import Filters from '../Components/Filter/Filters';
import Header from '../../../components/Headers/Header';
import DataTables from '../../../components/Tables/DataTables';
import DotsSpinner from '../../../components/Loader/DotsSpinner/DotsSpinner';

import { State } from '../../../Reducers/types';
import { TypeTicket } from '../../../types';
import { generateTicketReport } from '../../../Services/Reports/ReportService';

export default function TicketReport() {

    const refDownloadFile = useRef<any>();

    const reportfilter:any = {}
    // const reportfilter = useSelector((state: State) => state.reportFilter.reportFilter);
    const ITEM_LIMIT = 200; // item limit per report file

    const [ticketData, setTicketData] = useState<TypeTicket[]>([]); // ticket data
    const [ticketStat, setTicketStat] = useState<any>({
        grievance: {
            no_of_grievnce_reported: 0,
            no_of_grievnce_resolved: 0,
            grievance_resolved_in_time: 0,
            grievance_resolved_with_delay: 0,
            average_time_for_resolved_grievance: 'Not Available',
            no_of_grievnce_pending: 0,
        },
        query: {
            no_of_query_reported: 0,
            no_of_query_resolved: 0,
            query_resolved_in_time: 0,
            query_resolved_with_delay: 0,
            average_time_for_resolved_query: 'Not Available',
            no_of_query_pending: 0,
        },
        support: {
            no_of_support_reported: 0,
            no_of_support_resolved: 0,
            no_of_support_pending: 0,
        }
    }); // ticket stat
    const [totalItemCount, setTotalItemCount] = useState<number>(0); // stores total items(student entries) available in DB for the report
    const [totalPages, setTotalPages] = useState(0); // stores total pages available for the report - Math.cail(totalItemCount/ITEM_LIMIT)
    const [offset, setOffset] = useState<number>(0); // offset for pagination
    const [reportData, setReportData] = useState<any>(null); // stores report data

    const [array, setArray] = useState<number[]>([]); // stores the elements of the report to be exported as csv(Number of CSVs to be generated = array.length)
    const [fileName, setFileName] = useState<string>(""); // stores the file name to be exported as csv

    // loading
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDownloadingReport, setIsDownloadingReport] = useState<boolean>(false); // for download file loader

    useEffect(() => {
        // get the total number of items available for the report
        fetchTicketData();
        setFileName(`Ticket_Report_${moment().format('DD-MM-YYYY')}`);
    }, [reportfilter]);

    // fetches ticket data
    const fetchTicketData = () => {
        setIsLoading(true);

        generateTicketReport(
            reportfilter.start_date,
            reportfilter.end_date,
        ).then(
            (response: AxiosResponse) => {
                // console.log("Response for reports data: ", response?.data?.data);
                setTicketData(response?.data?.data);
                let grievance = [];
                let query = [];
                let support = [];

                response?.data?.data?.forEach((each) => {
                    if (each?.query_type === 'greivance') {
                        grievance.push(each);
                    } else if (each?.query_type === 'query') {
                        query.push(each);
                    } else {
                        support.push(each);
                    }
                });

                // sets values for stats
                setTicketStat(
                    {
                        grievance: {
                            no_of_grievnce_reported: grievance?.length || 0,
                            no_of_grievnce_resolved: grievance?.filter((each) => (each?.status === 'closed'))?.length || 0,
                            grievance_resolved_in_time: grievance?.filter((each) => (+each?.resolved_with_in <= 7 && +each?.resolved_with_in !== -1))?.length || 0,
                            grievance_resolved_with_delay: grievance?.filter((each) => (+each?.resolved_with_in > 7))?.length || 0,
                            average_time_for_resolved_grievance: Math.round(grievance?.reduce((accu, each) => (accu += +each?.resolved_with_in), 0) / grievance?.length) + ' Days' || 'Not Available',
                            no_of_grievnce_pending: grievance?.filter((each) => (each?.status === 'pending'))?.length || 0,
                        },
                        query: {
                            no_of_query_reported: query?.length || 0,
                            no_of_query_resolved: query?.filter((each) => (each?.status === 'closed'))?.length || 0,
                            query_resolved_in_time: query?.filter((each) => (+each?.resolved_with_in <= 2 && +each?.resolved_with_in !== -1))?.length || 0,
                            query_resolved_with_delay: query?.filter((each) => (+each?.resolved_with_in > 2))?.length || 0,
                            average_time_for_resolved_query: Math.round(query?.reduce((accu, each) => (accu += +each?.resolved_with_in), 0) / query?.length) + ' Days' || 'Not Available',
                            no_of_query_pending: query?.filter((each) => (each?.status === 'pending'))?.length || 0,
                        },
                        support: {
                            no_of_support_reported: support?.length || 0,
                            no_of_support_resolved: support?.filter((each) => (each?.status === 'closed'))?.length || 0,
                            no_of_support_pending: support?.filter((each) => (each?.status === 'pending'))?.length || 0
                        }
                    }
                );

            }, (error) => {
                console.log("Error caught: ", error?.response);
            }
        ).finally(() => {
            setIsLoading(false);
        });
    };

    const handleDownloadReport = () => {
        setIsDownloadingReport(true);
        setFileName(`Ticket_Report_${moment().format('DD-MM-YYYY')}`);
        let grievance = [];
        let query = [];
        let support = [];

        ticketData?.forEach((each) => {
            if (each?.query_type === 'greivance') {
                grievance.push(each);
            } else if (each?.query_type === 'query') {
                query.push(each);
            } else {
                support.push(each);
            }
        });
        // form data to download CSV
        let listData = [{
            no_of_grievnce_reported: grievance?.length || 0,
            no_of_grievnce_resolved: grievance?.filter((each) => (each?.status === 'closed'))?.length || 0,
            grievance_resolved_in_time: grievance?.filter((each) => (+each?.resolved_with_in <= 7 && +each?.resolved_with_in !== -1))?.length || 0,
            grievance_resolved_with_delay: grievance?.filter((each) => (+each?.resolved_with_in > 7))?.length || 0,
            average_time_for_resolved_grievance: Math.round(grievance?.reduce((accu, each) => (accu += +each?.resolved_with_in), 0) / grievance?.length) + ' Days' || 'Not Available',
            no_of_grievnce_pending: grievance?.filter((each) => (each?.status === 'pending'))?.length || 0,
            "*": "",
            no_of_query_reported: query?.length || 0,
            no_of_query_resolved: query?.filter((each) => (each?.status === 'closed'))?.length || 0,
            query_resolved_in_time: query?.filter((each) => (+each?.resolved_with_in <= 2 && +each?.resolved_with_in !== -1))?.length || 0,
            query_resolved_with_delay: query?.filter((each) => (+each?.resolved_with_in > 2))?.length || 0,
            average_time_for_resolved_query: Math.round(query?.reduce((accu, each) => (accu += +each?.resolved_with_in), 0) / query?.length) + ' Days' || 'Not Available',
            no_of_query_pending: query?.filter((each) => (each?.status === 'pending'))?.length || 0,
            "": "",
            no_of_support_reported: support?.length || 0,
            no_of_support_resolved: support?.filter((each) => (each?.status === 'closed'))?.length || 0,
            no_of_support_pending: support?.filter((each) => (each?.status === 'pending'))?.length || 0,
        }];
        let header = [
            { label: "Number of Grievance Reported", key: "no_of_grievnce_reported" },
            { label: "Number of Grievance Resolved", key: "no_of_grievnce_resolved" },
            { label: "Grievance Resolved In Time", key: "grievance_resolved_in_time" },
            { label: "Grievance Resolved With Delay", key: "grievance_resolved_with_delay" },
            { label: "Average Time To Resolve Grievance", key: "average_time_for_resolved_grievance" },
            { label: "Number of Grievance Pending", key: "no_of_grievnce_pending" },
            { label: '**********', key: '**********' },
            { label: "Number of Query Reported", key: "no_of_query_reported" },
            { label: "Number of Query Resolved", key: "no_of_query_resolved" },
            { label: "Query Resolved in Time", key: "query_resolved_in_time" },
            { label: "Query Resolved With Delay", key: "query_resolved_with_delay" },
            { label: "Average Time To Resolve Query", key: "average_time_for_resolved_query" },
            { label: "Number of Query Pending", key: "no_of_query_pending" },
            { label: '**********', key: '**********' },
            { label: 'Number of Support Reported', key: "no_of_support_reported" },
            { label: "Number of Support Resolved", key: "no_of_support_resolved" },
            { label: "Number of Support Pending", key: "no_of_support_pending" }
        ];
        console.log("Data: ", listData, " Header: ", header);
        setReportData((oldData) => ({ ...oldData, data: listData, headers: header }));
        refDownloadFile?.current?.getElementsByTagName("a")[0]?.click();
        setIsDownloadingReport(false);
    };

    return (
        <React.Fragment>
            <Header />

            <Container className="mt--7" fluid>
                <Card className="mb-4 mb-xl-0">
                    <CardHeader className="border-0">
                        <div className="d-flex justify-content-between">
                            <h3 className="mb-0 text-muted">
                                <i className="fas fa-file-invoice mr-1"></i> Ticket Stats
                            </h3>
                            <div>
                                {ticketData?.length !== 0 ?
                                    <Button
                                        color="primary"
                                        size="sm"
                                        className="mb-2 ml-0"
                                        disabled={isDownloadingReport}
                                        onClick={() => { handleDownloadReport() }}
                                    >Download File <i className="fas fa-file-download"></i></Button>
                                    : <></>}
                            </div>
                        </div>

                        <div className="pt-2">
                            <Filters
                                districtFilter={false}
                                blockFilter={false}
                                schoolFilter={false}
                                weekMonth={false}
                                showFilterText={false}
                            />
                        </div>
                    </CardHeader>

                    <CardBody>
                        <div className="d-flex justify-content-center">
                            {ticketData?.length !== 0 ? <button
                                ref={refDownloadFile}
                                className="d-none"
                            >
                                <CSVLink
                                    data={reportData?.data ? reportData?.data : []}
                                    headers={reportData?.headers ? reportData?.headers : []}
                                    filename={`${fileName}.csv`}
                                >
                                    Download List <i className="fas fa-file-download ml-1"></i>
                                </CSVLink>
                            </button> : <></>}
                            {isLoading ? <DotsSpinner /> : <></>}
                        </div>

                        {!isLoading ?
                            ticketData?.length !== 0 ?
                                <div className="d-flex justify-content-between">
                                    <Card className="mb-2">
                                        <CardHeader className="border-0"><i className="fas fa-dot-circle text-warning"></i> Grievance</CardHeader>
                                        <CardBody className="pt-0 d-flex flex-column">
                                            <span><span className="font-weight-bold">Reported:</span> {ticketStat?.grievance?.no_of_grievnce_reported}</span>
                                            <span><span className="font-weight-bold">Resolved:</span> {ticketStat?.grievance?.no_of_grievnce_resolved}</span>
                                            <span><span className="font-weight-bold">Resolved in time:</span> {ticketStat?.grievance?.grievance_resolved_in_time}</span>
                                            {/* <span><span className="font-weight-bold">Resolves with delay:</span> {ticketStat?.grievance?.grievance_resolved_with_delay}</span>
                                        <span><span className="font-weight-bold">Average time to resolve:</span> {ticketStat?.grievance?.average_time_for_resolved_grievance}</span>
                                        <span><span className="font-weight-bold">Pending:</span> {ticketStat?.grievance?.no_of_grievnce_pending}</span> */}
                                        </CardBody>
                                    </Card>

                                    <Card className="mb-2">
                                        <CardHeader className="border-0"><i className="fas fa-dot-circle text-info"></i> Query</CardHeader>
                                        <CardBody className="pt-0 d-flex flex-column">
                                            <span><span className="font-weight-bold">Reported:</span> {ticketStat?.query?.no_of_query_reported}</span>
                                            <span><span className="font-weight-bold">Resolved:</span> {ticketStat?.query?.no_of_query_resolved}</span>
                                            <span><span className="font-weight-bold">Resolved in time:</span> {ticketStat?.query?.query_resolved_in_time}</span>
                                            {/* <span><span className="font-weight-bold">Resolves with delay:</span> {ticketStat?.query?.query_resolved_with_delay}</span>
                                        <span><span className="font-weight-bold">Average time to resolve:</span> {ticketStat?.query?.average_time_for_resolved_query}</span>
                                        <span><span className="font-weight-bold">Pending:</span> {ticketStat?.query?.no_of_query_pending}</span> */}
                                        </CardBody>
                                    </Card>

                                    <Card className="mb-2">
                                        <CardHeader className="border-0"><i className="fas fa-dot-circle text-primary"></i> Support</CardHeader>
                                        <CardBody className="pt-0 d-flex flex-column">
                                            <span><span className="font-weight-bold">Reported:</span> {ticketStat?.support?.no_of_support_reported}</span>
                                            <span><span className="font-weight-bold">Resolved:</span> {ticketStat?.support?.no_of_support_resolved}</span>
                                            <span><span className="font-weight-bold">Resolved in time:</span> {ticketStat?.support?.no_of_support_pending}</span>
                                        </CardBody>
                                    </Card>
                                </div>
                                : <div className="d-flex justify-content-center align-items-center test-muted">No Data Available!</div>
                            : <DotsSpinner />}

                    </CardBody>
                </Card>
            </Container>
        </React.Fragment>
    )
}
